import config from '../config/index.js';

export const fetchProducts = async (search = '', category = '') => {
  try {
    const queryParams = new URLSearchParams();
    if (search) queryParams.append('search', search);
    if (category) queryParams.append('category', category);

    const response = await fetch(`${config.apiBaseUrl}/get_products.php?${queryParams}`);
    const data = await response.json();

    // Check if data is in the expected format
    if (!data || !data.success) {
      throw new Error(data?.message || 'Failed to fetch products');
    }

    // Return the products array
    return Array.isArray(data.products) ? data.products : [];
  } catch (error) {
    console.error('Error fetching products:', error);
    throw error;
  }
};

export const verifyProduct = async (code) => {
  try {
    const response = await fetch(`${config.apiBaseUrl}/verify_product`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ code }),
    });

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error verifying product:', error);
    throw error;
  }
};
